import Radio from "backbone.radio";
import { useEffect } from "react";
import { AuthRoute, useRouteMatch } from "extensions/react-router";

import { AdminDashboard } from "./index";

export function AdminDashboardRouter() {
    const { url } = useRouteMatch();
    return (
        <AuthRoute path={`${url}/dashboard/:section?/:qualifiers?`} component={DashboardComponent} />
    );
}

function DashboardComponent() {
    useEffect(() => {
        Radio.channel("main").request("show:app:view", <AdminDashboard />, {
            name: "Production dashboard",
            waitForAttach: true,
            hideDatePicker: true
        });
    });
    
    return null;
}
